import clsx from "clsx";
import { type FieldError } from "react-hook-form";
import { useTranslation } from "react-i18next";

type PropsType = {
  errorMessage: FieldError | string | undefined;
  className?: string;
  namespace?: string;
};

function isErrorMessage(error: FieldError | string | undefined): error is FieldError {
  return typeof error === "object";
}

function isError(error: FieldError | string | undefined): error is FieldError | string {
  return (isErrorMessage(error) && !!error.message) || (typeof error === "string" && !!error);
}

export default function RHErrorMessage({ errorMessage, className, namespace }: PropsType) {
  const { t } = useTranslation(namespace || "translation");

  if (!isError(errorMessage)) {
    return null;
  }

  const message = isErrorMessage(errorMessage) ? errorMessage.message : errorMessage;

  if (!message) {
    return null;
  }

  return <div className={clsx("TT-error-feedback", className)}>{namespace ? t(message) : message}</div>;
}
